
<section class="LoginView hero is-fullheight is-dark is-bold">
	<div class="hero-body">
		<div class="container">
			<div class="columns is-vcentered">
				<div class="column is-4 is-offset-4">
					<img
						:src="`${path}/img/${logoFilename}`"
						alt="Routes Planner Logo"
						class="LoginView__Logo"
					/>
					<h1 class="title">Logowanie</h1>
					<!-- <form class="box" @submit="login" :disabled="isProccessing"> -->
					<form class="box" :disabled="isProccessing">
						<label class="label">Email</label>
						<p class="control">
							<input
								class="input"
								type="text"
								placeholder="jan.kowalski@gmail.com"
								v-model="user.username"
								:disabled="isProccessing"
							/>
						</p>
						<label class="label">Hasło</label>
						<p class="control">
							<input
								class="input"
								type="password"
								placeholder="●●●●●●●"
								v-model="user.password"
								:disabled="isProccessing"
							/>
						</p>
						<hr />
						<div class="notification is-danger" v-show="errorMsg">{{ errorMsg }}</div>
						<p class="control">
							<!-- <button class="button is-primary" :class="{ 'is-loading': isProccessing }" :disabled="isProccessing">Zaloguj</button> -->
							<button
								class="button is-primary"
								:class="{ 'is-loading': isProccessing }"
								:disabled="isProccessing"
								@click.prevent="login"
							>
								Zaloguj
							</button>
						</p>
					</form>
				</div>
			</div>
		</div>
	</div>
</section>
